module.exports = __webpack_public_path__ + "static/media/404-graphic.67cdb2b1.png";